module.exports = __webpack_public_path__ + "img/appAsset-brand--Slack.2e302d1a.svg";